
/*
    チェック内容はおいおい改善していく

*/


module.exports.checkbox_checked = (DOM_checkbox,option={})=>{
    return (DOM_checkbox.checked);
}

module.exports.checkbox_not_checked = (DOM_checkbox,option={})=>{
    return !module.exports.checkbox_checked(DOM_checkbox);
}

module.exports.select_default = (DOM_select,option={})=>{
    return (DOM_select.selectedIndex === 0)
}


module.exports.select_not_default = (DOM_select,option={})=>{
    return (DOM_select.selectedIndex !== 0)
}


module.exports.input_empty = (DOM_input_or_textarea,option={})=>{
    let text;

    switch(DOM_input_or_textarea.tagName){
        case 'INPUT':
            text = DOM_input_or_textarea.value;
            break;
        case 'TEXTAREA':
            text = DOM_input_or_textarea.value;
            break;
    }

    if('check_after_trimmed' in option){
        text = text.trim();
    }
    return (text.length === 0);
}

module.exports.input_valid_email = (DOM_input,option={})=>{
    let text;

    let validator;
    validator = option.validator;

    text = DOM_input.value;

    if('check_after_trimmed' in option){
        text = text.trim();
    }

    return validator.isEmail(text);
}

module.exports.input_valid_youtube_url = (DOM_input,option={})=>{
    let text;
    let validator;
    validator = option.validator;

    text = DOM_input.value;

    if('check_after_trimmed' in option){
        text = text.trim();
    }

    if(validator.isURL(text) === false) return false;

    if(text.startsWith("https://www.youtube.com/")) return true;
    if(text.startsWith("https://youtu.be/")) return true;

    return false;
}
